import { Inject, Injectable } from '@angular/core';
import { AuthCheckService, HrefResolverService, ServicePathProviderService } from '@blk/cwp-ng-framework';
import * as get from 'lodash/get';
import * as set from 'lodash/set';
import { Observable } from 'rxjs';
import { first } from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})
export class UserPlatformAuthenticationService {
	private isAuthorized: boolean;
	private readonly currentUrl: string;

	constructor(
		@Inject('environment') private environment: any,
		private authCheckService: AuthCheckService,
		private hrefResolver: HrefResolverService,
		private servicePathProvider: ServicePathProviderService
	) {
		// Capture current URL before any routing logic changes the URL for SSO redirect purposes
		this.currentUrl = encodeURIComponent(window.location.href.replace(new RegExp('^([^?]*).*'), '$1'));
	}

	public checkAuthentication(authSuccessCallback: Function): void {
		const isLoginFlowRequired = get(window, 'BLK.apiGatewayCheck', true);
		if (isLoginFlowRequired) {
			this.authCheckService.isAuthorised(false).pipe(first()).subscribe(
				auth => {
					this.isAuthorized = auth;
				},
				err => {
					this.isAuthorized = false;
					console.error('Auth check failed - performing full page auth redirect.');
					this.reInitializeCwpSession();
				},
				() => {
					if (!this.isAuthorized) {
						this.initiateSsoRedirect();
					} else {
						// Execute the success callback
						if (authSuccessCallback !== undefined && typeof authSuccessCallback === 'function') {
							authSuccessCallback();
						}
						// Call CWP components success API gateway callback
						try {
							if (window['BLK']) {
								set(window, 'BLK.apiGateway._isAuthenticated', true);
								if (get(window, 'BLK.apiGateway._isAuthenticating')) {
									window['BLK'].apiGateway._executeCallbacks(window['BLK'].apiGateway._callbackQueue.success, true);
								}
							}
						} catch (e) {
							console.error('CWP callback failed', e);
						}
					}
				}
			);
		}
	}

	private reInitializeCwpSession(): void {
		if (window['partner_name']) {
			// checking analytics variable for partner user
			// for partner session go to full redirect
			this.initiateSsoRedirect();
		} else {
			// perform CWP session reinitialisation
			const signOn: string = this.hrefResolver.getResolvedUrl('sign-on');
			const queryString = window.location.href.indexOf('?') >= 0 ? window.location.href.substr(window.location.href.indexOf('?')) : '';
			const redirect: string = encodeURIComponent(window.location.pathname + queryString);

			if (signOn) {
				window.location.href = signOn + '?redirectUrl=' + redirect;
			}
		}
	}

	public initiateSsoRedirect(): void {
		const apiGateway: string = this.servicePathProvider.getServicePath('api-gateway');
		const errorPage: string = this.hrefResolver.getResolvedUrl('errorPage');
		const nautilusSsoUrl: string = this.hrefResolver.getResolvedUrl('nautilusSso') + '?target=' + this.currentUrl;

		const successRedirect: string = encodeURIComponent(window.location.href);
		const failureRedirect: string = encodeURIComponent(errorPage);

		const nautilusLoginPath: string = apiGateway + '/login?successRedirect=' + successRedirect + '&failureRedirect=' + failureRedirect;

		if (this.environment.production) {
			window.location.href = nautilusLoginPath;
		} else {
			window.location.href = nautilusSsoUrl;
		}
	}

	public isUserAuthenticated(): Observable<boolean> {
		return this.authCheckService.isAuthorised();
	}

}
